export const BASE_URL_GRAPH = "https://graph.microsoft.com/v1.0";
export const BASE_URL = "https://func-provisioning-prod-ne.azurewebsites.net";